import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../../../common/_common.scss'
import AdviserProfileWorkExperience from '../../../../../common/AdviserProfiles/AdviserProfileWorkExperience'
import EditButton from '../../../../../common/forms/EditButton'
import DeleteButton from '../../../../../common/forms/DeleteButton'
import AdviserWorkExperienceEditor from './AdviserWorkExperienceEditor'
import * as styles from './_PendingApprovalAdviserProfileWorkExperienceEditor.scss'
import { Modal } from 'react-bootstrap'
import PrimaryActionButton from '../../../../../common/Buttons/PrimaryActionButton'
import SecondaryActionButton from '../../../../../common/Buttons/SecondaryActionButton'
import { modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  setAddNewWorkExperience
  , setStartEditingWorkExperience
  , setStopEditingWorkExperience
  , setCancelEditingWorkExperience
  , setWorkExperience
  , setWorkExperiencePositionStartMonth
  , setWorkExperiencePositionStartYear
  , setWorkExperiencePositionEndMonth
  , setWorkExperiencePositionEndYear
  , setWorkExperiencePositionEndDateCurrent
  , setDeleteWorkExperienceModal
  , setDeletingWorkExperience
  , setDeletedWorkExperience
  , deleteWorkExperience
  , setCancelDeletingWorkExperience
} from './pendingApprovalAdviserProfileWorkExperienceEditorActions.js'

class adviserProfileWorkExperienceEditor extends React.Component {
  static propTypes = {
    pendingApprovalProfile: PropTypes.object.isRequired,
    publishedProfile: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    editingProfile: PropTypes.bool.isRequired,

    setAddNewWorkExperience: PropTypes.func.isRequired,
    setStartEditingWorkExperience: PropTypes.func.isRequired,
    setStopEditingWorkExperience: PropTypes.func.isRequired,
    setCancelEditingWorkExperience: PropTypes.func.isRequired,
    setWorkExperience: PropTypes.func.isRequired,
    setWorkExperiencePositionStartMonth: PropTypes.func.isRequired,
    setWorkExperiencePositionStartYear: PropTypes.func.isRequired,
    setWorkExperiencePositionEndMonth: PropTypes.func.isRequired,
    setWorkExperiencePositionEndYear: PropTypes.func.isRequired,
    setWorkExperiencePositionEndDateCurrent: PropTypes.func.isRequired,
    setDeleteWorkExperienceModal: PropTypes.func.isRequired,
    deleteWorkExperience: PropTypes.func.isRequired,
    setDeletingWorkExperience: PropTypes.func.isRequired,
    setDeletedWorkExperience: PropTypes.func.isRequired,
    setCancelDeletingWorkExperience: PropTypes.func.isRequired,
    workExperiencesModifications: PropTypes.array.isRequired,

    loadingWorkExperience: PropTypes.bool.isRequired,
    editingWorkExperience: PropTypes.bool.isRequired,
    editingWorkExperienceIndex: PropTypes.number.isRequired,
    deletingWorkExperience: PropTypes.bool.isRequired,
    deletingWorkExperienceModal: PropTypes.bool.isRequired,
    deletingWorkExperienceIndex: PropTypes.number.isRequired,
    positionStartMonth: PropTypes.number,
    positionStartYear: PropTypes.number,
    positionEndMonth: PropTypes.number,
    positionEndYear: PropTypes.number
  };

  componentDidMount () {
    this.setState({})
  }

  componentDidUpdate(prevProps)  {
    if (!prevProps.deletingWorkExperience && this.props.deletingWorkExperience) {
      this.props.setDeletedWorkExperience()
    }
  }

  renderPreview () {
    const editDeleteButtons = (index) => {
      return <span key={index}>
        <EditButton
          editing={this.props.editingWorkExperience}
          startEditing={() => {
            this.props.setStartEditingWorkExperience(index)
          }} />
        |
        <DeleteButton
          startDeleting={() => {
            this.props.setDeleteWorkExperienceModal(index)
          }} />
      </span>
    }

    const children = this.props.workExperiencesModifications.map((experience, index) => {
      if (experience.modificationState === modificationStates.deleted) {
        return <span key={index} />
      } else {
        return editDeleteButtons(index)
      }
    })

    return <div className={styles['form-bottom-margin'] + ' modal-container'}>
      <AdviserProfileWorkExperience experiences={this.props.workExperiencesModifications} className={styles['no-bottom-padding']} comparison hideDeleted={this.props.editingProfile}>
        {this.props.editingProfile && children ? children : null}
      </AdviserProfileWorkExperience>
      {this.props.editingProfile &&
        <a
          className={styles['add-work-button']}
          target='blank'
          onClick={() => {
            this.props.setAddNewWorkExperience()
          }}
        >
          Add work experience to your profile
        </a>
      }
      <Modal
        show={this.props.deletingWorkExperienceModal}
        aria-labelledby='contained-modal-title' >
        <Modal.Header style={{ borderBottom: 'none', paddingLeft: '40px', paddingRight: '40px', paddingTop: '40px' }}>
          <h2>Deleting experience</h2>
        </Modal.Header>
        <Modal.Body style={{ paddingLeft: '40px', paddingRight: '40px' }}>
          <p>Are you sure you wish to delete "{this.props.deletingWorkExperienceIndex !== -1 ? this.props.workExperiencesModifications[this.props.deletingWorkExperienceIndex].position : ''}" experience?</p>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
          <PrimaryActionButton
            className={commonStyles['delete-confirmation-modal-button']}
            buttonText='Delete'
            onClick={() => {
              this.props.deleteWorkExperience()
            }}
          />
          <SecondaryActionButton
            buttonText='Cancel'
            onClick={() => {
              this.props.setCancelDeletingWorkExperience()
            }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  }

  renderEditor () {
    return <AdviserProfileWorkExperience experiences={this.props.workExperiencesModifications} editor editingIndex={this.props.editingWorkExperienceIndex} hideDeleted className={styles['no-bottom-padding']} >
      {this.props.workExperiencesModifications.map((experience, index) => {
        if (this.props.editingWorkExperienceIndex === index) {
          return <AdviserWorkExperienceEditor
            key={index}
            formIsValid={this.props.formIsValid}
            experience={experience}
            editingWorkExperience={this.props.editingWorkExperience}
            validationstate={this.props.validationstate}
            stopEditingWorkExperience={() => {
              this.props.setStopEditingWorkExperience()
            }}
            cancelEditingWorkExperience={() => {
              this.props.setCancelEditingWorkExperience()
            }}
            positionHandleChange={(validationResult, value) => {
              this.props.setWorkExperience(validationResult, {
                position: value,
                company: experience.company,
                isCurrentJob: experience.isCurrentJob,
                modificationState: experience.modificationState,
                positionEndDate: experience.positionEndDate,
                positionStartDate: experience.positionStartDate
              })
            }}
            companyHandleChange={(validationResult, value) => {
              this.props.setWorkExperience(validationResult, {
                position: experience.position,
                company: value,
                isCurrentJob: experience.isCurrentJob,
                modificationState: experience.modificationState,
                positionEndDate: experience.positionEndDate,
                positionStartDate: experience.positionStartDate
              })
            }}
            dateHandleChange={() => {
              let validationResult = {
                position: this.props.validationstate.position,
                company: this.props.validationstate.company
              }
              this.props.setWorkExperience(validationResult, {
                position: experience.position,
                company: experience.company,
                isCurrentJob: experience.isCurrentJob,
                modificationState: experience.modificationState,
                positionStartDate: experience.positionStartDate,
                positionEndDate: experience.positionEndDate
              })
            }}
            positionStartMonth={this.props.positionStartMonth}
            positionStartYear={parseInt(this.props.positionStartYear)}
            positionEndMonth={this.props.positionEndMonth}
            positionEndYear={parseInt(this.props.positionEndYear)}
            handlePositionStartMonth={(validationResult, value) => {
              this.props.setWorkExperiencePositionStartMonth(validationResult, value)
            }}
            handlePositionStartYear={(validationResult, value) => {
              this.props.setWorkExperiencePositionStartYear(validationResult, value)
            }}
            handlePositionEndMonth={(validationResult, value) => {
              this.props.setWorkExperiencePositionEndMonth(validationResult, value)
            }}
            handlePositionEndYear={(validationResult, value) => {
              this.props.setWorkExperiencePositionEndYear(validationResult, value)
            }}
            handleCurrentEndYear={() => {
              this.props.setWorkExperiencePositionEndDateCurrent()
            }}
            handleSubmit={() => {
              this.props.setStopEditingWorkExperience()
            }}
          />
        }
      })}
    </AdviserProfileWorkExperience>
  }

  render () {
    if (this.props.editingWorkExperience) {
      return this.renderEditor()
    }

    return this.renderPreview()
  }
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    loadingWorkExperience: adviserProfileApprovalEditorContainer.experiences.loadingWorkExperience,
    editingWorkExperience: adviserProfileApprovalEditorContainer.experiences.editingWorkExperience,
    editingWorkExperienceIndex: adviserProfileApprovalEditorContainer.experiences.editingWorkExperienceIndex,
    deletingWorkExperience: adviserProfileApprovalEditorContainer.experiences.deletingWorkExperience,
    deletingWorkExperienceModal: adviserProfileApprovalEditorContainer.experiences.deletingWorkExperienceModal,
    deletingWorkExperienceIndex: adviserProfileApprovalEditorContainer.experiences.deletingWorkExperienceIndex,
    positionStartMonth: adviserProfileApprovalEditorContainer.experiences.positionStartMonth,
    positionEndMonth: adviserProfileApprovalEditorContainer.experiences.positionEndMonth,
    positionStartYear: adviserProfileApprovalEditorContainer.experiences.positionStartYear,
    positionEndYear: adviserProfileApprovalEditorContainer.experiences.positionEndYear,
    formIsValid: adviserProfileApprovalEditorContainer.experiences.isInvalid.formIsValid,
    validationstate: adviserProfileApprovalEditorContainer.experiences.isInvalid,
    allEducation: adviserProfileApprovalEditorContainer.experiences.allEducation,
    workExperiencesModifications: adviserProfileApprovalEditorContainer.experiences.workExperiencesModifications,
    editingProfile: adviserProfileApprovalEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setAddNewWorkExperience: setAddNewWorkExperience,
    setStartEditingWorkExperience: setStartEditingWorkExperience,
    setStopEditingWorkExperience: setStopEditingWorkExperience,
    setCancelEditingWorkExperience: setCancelEditingWorkExperience,
    setWorkExperience: setWorkExperience,
    setWorkExperiencePositionStartMonth: setWorkExperiencePositionStartMonth,
    setWorkExperiencePositionStartYear: setWorkExperiencePositionStartYear,
    setWorkExperiencePositionEndMonth: setWorkExperiencePositionEndMonth,
    setWorkExperiencePositionEndYear: setWorkExperiencePositionEndYear,
    setWorkExperiencePositionEndDateCurrent: setWorkExperiencePositionEndDateCurrent,
    setDeleteWorkExperienceModal: setDeleteWorkExperienceModal,
    deleteWorkExperience: deleteWorkExperience,
    setDeletingWorkExperience: setDeletingWorkExperience,
    setDeletedWorkExperience: setDeletedWorkExperience,
    setCancelDeletingWorkExperience: setCancelDeletingWorkExperience
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileWorkExperienceEditor))
